import React from 'react';
import PropTypes from 'prop-types';

import {
  Box, Typography,
} from '@mui/material';
import usePortfolioStyle from '../../styles/PortfolioStyles.jsx';

import Application from './Application.jsx';

import Biteshare from '../../assets/portfolio/biteshare/Biteshare.png';

import Service from '../../assets/portfolio/systemDesign/service.png';

import ProductOverview from '../../assets/portfolio/atelier/overview.png';
import ProductRelated from '../../assets/portfolio/atelier/related.png';
import ProductReview from '../../assets/portfolio/atelier/reviews.png';

import Space from '../../assets/portfolio/spaceObserver/space.gif';

const Portfolio = ({ theme, isMobile }) => {
  const {
    root,
    portfolioContainer,
    portfolioContainerMobile,
    header,
  } = usePortfolioStyle();
  const applications = [
    {
      title: 'Biteshare',
      demos: [Biteshare],
      link: 'https://github.com/tm2838/biteshare',
      description: 'A full-stack mobile application for seamlessly splitting bills',
      stack: ['React Native', 'Expo', 'Firebase'],
    },
    {
      title: 'Atelier - Backend',
      demos: [Service],
      link: 'https://github.com/tm2838/Product-Overview-Service',
      description: 'A microservice system supporting a legacy e-commerce front end',
      stack: ['Node.js', 'Express.js', 'MongoDB', 'AWS'],
    },
    {
      title: 'Atelier - Frontend',
      demos: [ProductOverview, ProductRelated, ProductReview],
      link: 'https://github.com/tm2838/Atelier',
      description: 'A single page application (SPA) for an e-commerce website',
      stack: ['React', 'React Router', 'Redux', 'Node.js', 'Express.js'],
    },
    {
      title: 'Space Observer',
      demos: [Space],
      link: 'https://github.com/tm2838/space-observer',
      description: 'A full-stack application for star gazers',
      stack: ['React', 'React Router', 'TypeScript', 'Node.js', 'PostgreSQL'],
    },
  ];

  return (
    <Box className={root}>
      <Typography className={header}>
        Software Applications
      </Typography>

      <Box className={isMobile ? portfolioContainerMobile : portfolioContainer}>
        {applications.map(
          app => <Application
            key={app.title}
            title={app.title}
            demos={app.demos}
            link={app.link}
            description={app.description}
            stack={app.stack}
            theme={theme}
            isMobile={isMobile}
          />,
        )}
      </Box>
    </Box>
  );
};

Portfolio.propTypes = {
  theme: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default Portfolio;
